import { Box, Text, List, ListItem, Heading } from "@chakra-ui/react";

const PERMISSIONS_MAP: Record<string, string[]> = {
  ADMIN: ["Acesso total a todas as funcionalidades do sistema"],
  MANAGER: [
    "Dashboard",
    "Links de Pagamento (Pontual e Assinaturas)",
    "Cobranças",
    "Clientes",
    "Financeiro",
    "Relatórios",
    "Antecipação",
    "Visualização de Notificações",
  ],
  FINANCE: [
    "Dashboard",
    "Clientes",
    "Financeiro",
    "Relatórios",
    "Antecipação",
    "Visualização de Notificações",
  ],
  SUPERVISOR: [
    "Links de Pagamento (Pontual e Assinaturas)",
    "Cobranças",
    "Clientes",
    "Visualização de Notificações",
  ],
  SALE: [
    "Links de Pagamento (Pontual e Assinaturas)",
    "Cobranças",
    "Clientes",
  ],
};

interface UserPermissionsInfoProps {
  selectedProfile: string;
}

const UserPermissionsInfo: React.FC<UserPermissionsInfoProps> = ({ selectedProfile }) => {
  const permissions = PERMISSIONS_MAP[selectedProfile] || [];

  return (
    <Box
        position="absolute"
        top="0"
        right="0"
        left="102%"
        maxWidth="300px"
        w="100%"
        height="100%"
        backgroundColor="white"
        borderRadius="8px"
        p={4}
    >
        <Box>
            <Heading size="sm" mb={2}>Permissões do perfil selecionado:</Heading>
            {permissions.length === 0 ? (
                <Text color="gray.500">Selecione um perfil para ver as permissões</Text>
            ) : (
                <List spacing={1} styleType="disc" pl={4}>
                {permissions.map((item, idx) => (
                    <ListItem key={idx}>{item}</ListItem>
                ))}
                </List>
            )}
        </Box>
    </Box>
  );
};

export { UserPermissionsInfo };
